module.exports = __webpack_public_path__ + "img/small-title.a8f248b8.png";